import { render } from "./TheBikeCreationForm.vue?vue&type=template&id=3fe34a04"
import script from "./TheBikeCreationForm.vue?vue&type=script&lang=js"
export * from "./TheBikeCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__